import { Component } from 'react';
import { Link } from 'react-router';
import styles from './UserRow.scss';
import icons from 'styles/icons/icons.scss';
import UserInfo from './UserInfo/UserInfo';
import UserQuickActions from './UserQuickActions/UserQuickActions';
import UserQuickActionsV2 from './UserQuickActionsV2';

export default class UserRow extends Component {
    constructor(props) {
        super(props);
    }
    getPaths() {
        const {  user } = this.props;
        let paths = {
            user:  `/admin/users/${user.id}`,
            groups:  `/admin/groups?q=${user.displayName}`,
        };
        return paths;
    }

    render() {
        const {  user, isNewDoaEnabled, institutionId } = this.props;
        const userActive = user.isActive ? 'ACTIVE' : 'INACTIVE';
        const paths = this.getPaths();

        return (
            <div  className={styles.userRow} data-cy="UserRow">
                <header className={styles.header}>
                    <Link to={paths.user} className={styles.link}>
                        <div className={styles.icon}>
                            <span className={icons.materialIcons}>perm_identity</span>
                        </div>
                        <p className={styles.title} data-cy="UserRow-fullname">
                            { `${user.firstName} ${user.lastName} | ${userActive}` }
                        </p>
                    </Link>
                    <div className={styles.quickActions} data-cy="UserRow-UserQuickActions">
                        {
                            isNewDoaEnabled ? (
                                <UserQuickActionsV2
                                    user={user}
                                    institutionId={institutionId}
                                />
                            )
                                :
                                <UserQuickActions
                                    user={user}
                                    institutionId={institutionId} />
                        }
                    </div>
                </header>
                <UserInfo
                    user={user}
                    institutionId={institutionId}
                    groupsPath={paths.groups} />
            </div>
        );
    }
}
